import { Component, ChangeDetectorRef, ElementRef, NgZone, ViewChild, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpRequest, HttpResponse, HttpEventType } from "@angular/common/http";
import { AlertPanelModel } from '../../../../_models/common/alertPanelModel';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../../shared.module';

@Component({
    selector: 'formly-currency-image-uploder',
    templateUrl: "./formly-currency-image-uploder.component.html",
    standalone: true,
    imports: [CommonModule, TranslateModule, ReactiveFormsModule, FormlyModule, SharedModule]
})
export class FormlyImageUploderComponent extends FieldType {

  fieldKey: string;
  size: number;
  width: number;
  height: number;
  imgUrl: string;
  imgName: string;
  alertPanelModel = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
  public message: string;
  ShowErrorPanel: boolean = false;
  formSubmissionSubscription: Subscription;
  isFormSubmitted: boolean = false;
  filedata: any;

  constructor(private translate: TranslateService, private dynamicFormService: DynamicFormService, private zone: NgZone, private cdr: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    if (this.field.key) {
      this.fieldKey =this.field.id??this.field.key.toString();
    }
    this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
      this.isFormSubmitted = data;
    });
    this.imgUrl = this.field.templateOptions.orgLogo;
    this.formControl.setValue(this.field.templateOptions.orgLogo);
  }

  ngOnDestroy() {
    if (this.formSubmissionSubscription) {
      this.formSubmissionSubscription.unsubscribe();
    }
  }

  onChange(evt: any) {
    this.realImgDimension(evt);
    let tempFile = evt.target.files[0];

    if (tempFile) {
      let fileExtension = tempFile.type.split('/')[1];
      if (fileExtension &&
        (fileExtension.toLowerCase() == "png" ||
          fileExtension.toLowerCase() == "jpg" ||
          fileExtension.toLowerCase() == "jpeg")) {
      } else {
        this.ShowErrorPanel = true;
        this.alertPanelModel = new AlertPanelModel(
          true,
          this.field.templateOptions.alert,
          [],
          '',
          this.field.templateOptions.close,
          true
          ,
          this.field.templateOptions.formatNotSupport
        );
        return;
      }
      if (fileExtension && tempFile.size < 50000) {
      } else {
        this.ShowErrorPanel = true;
        this.alertPanelModel = new AlertPanelModel(
          true,
          this.field.templateOptions.alert,
          [],
          '',
          this.field.templateOptions.close,
          true
          ,
          this.field.templateOptions.fileSizeMessage
        );
        return;
      }
    }
    if (tempFile) {
      this.filedata = tempFile;
      this.formControl.setValue(tempFile);
      this.to.change(this.field, tempFile);
    }
  }

  realImgDimension(evt: any) {
    let image: any = evt.target.files[0];
    let fr = new FileReader();
    fr.readAsDataURL(image);

    fr.onload = (event) => {
      const dataUrl = event.target.result.toString();
      this.zone.run(() => {
        this.imgUrl = dataUrl;
        this.cdr.detectChanges();
      });
      var img = new Image();
      img.onload = () => {
        this.width = img.width;
        this.height = img.height;
        if (img.width > 50 && img.height > 50) {
          this.zone.run(() => {
            this.imgUrl = this.field.templateOptions.orgLogo;
            this.ShowErrorPanel = true;
            this.alertPanelModel = new AlertPanelModel(
              true,
              this.field.templateOptions.alert,
              [],
              '',
              this.field.templateOptions.close,
              true,
              this.field.templateOptions.widthHeighMessage
            );
            this.cdr.detectChanges();
          });
        }
      };
      img.src = dataUrl;
    };
  }


  alertPanelReceiver(returnValue) {
    this.ShowErrorPanel = false;
  }

}
